import { Box } from '@material-ui/core';
import React from 'react';
import { GraySmall } from '../../theme/colors';
import BaseTypography from '../Text/BaseTypography';

interface FormLabelProps {
  primaryText: string;
  secondaryText?: string;
  Typography?: React.ReactElement;
}
export const FormLabel: React.FC<FormLabelProps> = ({
  primaryText,
  secondaryText,
}) => (
  <Box>
    <BaseTypography fontType="13Medium" component="span">
      {primaryText}
    </BaseTypography>
    {secondaryText && (
      <BaseTypography component="span" style={{ color: GraySmall }}>
        {secondaryText}
      </BaseTypography>
    )}
  </Box>
);
